<template>
  <div>
    <div v-if="!dataLoaded">
      <v-progress-circular indeterminate color="primary" class="ret-center-absolute"></v-progress-circular>
    </div>
    <div v-if="dataLoaded" class="ret-cards-wrapper">
      <v-card class="ret-card-new">
        <v-card-title>
          <h3 class="headline">{{ $tc('users.entity-name', 1) }}</h3>
          <v-spacer></v-spacer>
          <v-btn
            v-if="item.id"
            text
            color="warn"
            @click="onDestroy(item)"
            data-test="archive"
          >{{ $t('archive') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <form @keyup.enter="save">
            <v-container fluid class="px-0">
              <v-row>
                <v-col xs="12" sm="2">
                  <v-text-field
                    v-model="editedItem.code"
                    :label="$t('code')"
                    :error-messages="itemErrors.code"
                    data-test="code"
                  ></v-text-field>
                </v-col>
                <v-col xs="12" sm="5">
                  <v-text-field
                    v-model="editedItem.firstname"
                    :label="$t('first-name')"
                    data-test="first-name"
                  ></v-text-field>
                </v-col>
                <v-col xs="12" sm="5">
                  <v-text-field
                    v-model="editedItem.lastname"
                    :label="$t('last-name')"
                    data-test="last-name"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="editedItem.email"
                    :label="$t('email')"
                    :error-messages="itemErrors.email"
                    data-test="email"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="4">
                  <v-select
                    v-model="editedItem.language"
                    :label="$t('language')"
                    :items="[
                      { text: 'English', value: 'en' },
                      { text: 'Česky', value: 'cs' },
                      { text: 'Français', value: 'fr' },
                      { text: 'Polski', value: 'pl' },
                    ]"
                    :menu-props="{bottom: true}"
                    data-test="language"
                  ></v-select>
                </v-col>
                <v-col xs="12" sm="4">
                  <v-select
                    v-model="editedItem.role"
                    :label="$t('role')"
                    :error-messages="itemErrors.role"
                    :items="userRoles"
                    :menu-props="{bottom: true}"
                    data-test="role"
                  ></v-select>
                </v-col>
                <v-col xs="12" sm="4">
                  <v-select
                    v-model="editedItem.userGroupId"
                    :label="$tc('user-group.entity-name', 1)"
                    :items="groups"
                    clearable
                    data-test="group"
                  ></v-select>
                </v-col>
                <v-col x="12" sm="4" v-if="$canm('assets', 'useOwners')">
                  <v-select
                    v-model="editedItem.ownerId"
                    :label="$t('assets.visibility-owner')"
                    :items="owners"
                    item-text="ancestorsAndThisString"
                    item-value="id"
                    :menu-props="{bottom: true}"
                    clearable
                    data-test="owner-id"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="4">
                  <v-checkbox
                    v-model="editedItem.shouldChangePassword"
                    :label="$t('should-change-password')"
                    data-test="should-change-password"
                  ></v-checkbox>
                </v-col>
                <v-col xs="12" sm="8">
                  <v-text-field
                    v-model="editedItem.password"
                    :label="$t('new-password')"
                    type="password"
                    :error-messages="itemErrors.password"
                    data-test="password"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="4">
                  <v-checkbox
                    v-model="editedItem.emailInfo"
                    :label="$t('email-info')"
                    data-test="send-notification-emails"
                  ></v-checkbox>
                </v-col>
                <v-col xs="12" sm="8">
                  <v-text-field
                    v-model="editedItem.passwordConfirmation"
                    :label="$t('new-password-again')"
                    type="password"
                    data-test="password-confirmation"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="$router.go(-1)" data-test="back">{{ $t('back') }}</v-btn>
          <v-btn
            @click="handleSaveClick"
            color="primary"
            :disabled="!isUnsaved"
            data-test="save"
          >{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import displayHelpers from '../helpers/display-helpers.es6'
import itemHelpers from '../helpers/item-helpers.es6'

export default {
  name: 'users',
  mixins: [displayHelpers, itemHelpers],
  data () {
    return {
      model: { name: 'users' },
      auxModels: [
        { name: 'owners', tree: true },
        { name: 'user-groups' }
      ]
    }
  },
  computed: {
    owners () {
      const sorted = this.$store.state.items['owners'].nodes
      sorted.sort((a, b) => {
        return a.ancestorsAndThisString > b.ancestorsAndThisString
      })
      return sorted
    },
    groups () {
      return this.$store.state.items['user-groups']
        .map(group => ({
          text: group.name,
          value: group.id
        }))
    },
    userRoles () {
      const roles = [
        { text: this.$t('admin'), value: 'admin' },
        { text: this.$t('manager'), value: 'manager' },
        { text: this.$t('dispatcher'), value: 'dispatcher' },
        { text: this.$t('worker'), value: 'worker' }
      ]
      return roles.filter((r) => this.$can(r.value))
    }
  }
}
</script>
